export default __webpack_public_path__ + "static/lsa-web-screens-fb3e4cbd9921026bfb41c53ff0380d9f.jpg";